/* Office Walker — Cloudflare Turnstile for the waitlist forms. Added 22 Sep 2026.
   Runs an invisible check when a waitlist form is submitted and adds the token
   (cf_turnstile) to the POST that ow-waitlist.js sends to n8n. If Cloudflare is
   blocked, slow or down, the signup still goes out without a token (15 s cap).
   While SITE_KEY still says PASTE_SITE_KEY_HERE this file does nothing. */
(function () {
  'use strict';
  var SITE_KEY = '0x4AAAAAAE_0wGsWvbxMQMA0';

  if (!SITE_KEY || SITE_KEY.indexOf('PASTE') === 0) { return; }
  if (window.__owTurnstile) { return; }
  window.__owTurnstile = true;

  try {
    var s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
    s.async = true;
    s.defer = true;
    document.head.appendChild(s);
  } catch (e) { return; }

  var pending = null;

  function isWaitlistForm(f) {
    return !!(f && f.tagName === 'FORM' && (f.hasAttribute('data-ow-wl-form') || f.id === 'ow-wl-form'));
  }

  function tokenFor(form) {
    return new Promise(function (resolve) {
      var done = false;
      function finish(t) { if (!done) { done = true; resolve(t || ''); } }
      window.setTimeout(function () { finish(''); }, 15000);
      try {
        if (!window.turnstile) { finish(''); return; }
        var box = form.querySelector('.ow-ts');
        if (!box) {
          box = document.createElement('div');
          box.className = 'ow-ts';
          box.style.marginTop = '10px';
          form.appendChild(box);
        }
        if (box.__owWid !== undefined) {
          try { window.turnstile.remove(box.__owWid); } catch (e) {}
        }
        box.__owWid = window.turnstile.render(box, {
          sitekey: SITE_KEY,
          appearance: 'interaction-only',
          size: 'flexible',
          callback: function (t) { finish(t); },
          'error-callback': function () { finish(''); return true; },
          'timeout-callback': function () { finish(''); },
          'unsupported-callback': function () { finish(''); }
        });
      } catch (e) { finish(''); }
    });
  }

  document.addEventListener('submit', function (e) {
    try { if (isWaitlistForm(e.target)) { pending = tokenFor(e.target); } } catch (err) {}
  }, true);

  var nativeFetch = window.fetch;
  if (!nativeFetch) { return; }
  window.fetch = function (url, opts) {
    try {
      if (pending && opts && typeof opts.body === 'string' &&
          opts.body.indexOf('email_address_check=') > -1) {
        var p = pending;
        pending = null;
        return p.then(function (t) {
          opts.body += '&cf_turnstile=' + encodeURIComponent(t || '');
          return nativeFetch.call(window, url, opts);
        }, function () {
          return nativeFetch.call(window, url, opts);
        });
      }
    } catch (e) {}
    return nativeFetch.apply(window, arguments);
  };
})();